import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Flex } from 'antd-mobile'
import _ from 'lodash'
import { devicePay, intl } from 'utils'
import DevicePay from 'components/PaymentMethods/DevicePay'
import WhiteSpace from 'components/WhiteSpace'
// import WingBlank from 'components/WingBlank'
import PaymentMethodButton from '../PaymentMethodButton'
import { Route, Switch, withRouter } from 'react-router-dom'
import { NavigatorWithQS } from 'utils/navigateWithQS'
import App from 'components/PaymentMethods/App'
import AaniPay from 'components/PaymentMethods/AaniPay'
import MobilePaymentContainer from '../MobilePaymentContainer'
import messages from './messages'
import AliPay from 'components/PaymentMethods/AliPay'
import payWithWallet from '../../routes/PayPage/Main/modules'

// 为移动端提供特殊处理
class PaymentMethodRender extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      index: 0,
      data: [],
      visible: false,
    }
    const { history, location } = props
    this.navigateWithQS = NavigatorWithQS.getInstance(history, location)
  }

  handleClick = (item, index) => {
    if (item.tabType === 'PAY_METHODS') {
      if (this.props.siteConfig.loginToken) {
        this.navigateWithQS.push('/pay-page/main/mobile-payment-container/card-pay')
      } else {
        this.navigateWithQS.push('/pay-page/main/mobile-payment-container/add-new-card')
      }
    }
    if (item.tabType === 'MESSAGE_PAY') {
      this.navigateWithQS.push('/pay-page/main/mobile-payment-container/message-pay')
    }
    if (item.tabType === 'WALLET_PAY') {
      payWithWallet({
        ...item,
      })
    }
    // 兼容原有埋点
  }

  componentDidMount = async () => {
    if (this.props.data && !_.isEqual(this.state.data, this.props.data)) {
      const data = await devicePay.filter(_.clone(this.props.data))
      const preferred = _.find(data, devicePay.preferred())
      preferred && _.remove(data, preferred)
      this.setState({
        origin: data,
        data,
        preferred,
      })
    }
  }

  render() {
    const { data, preferred } = this.state
    const { payPageMainState, submit, loading, pageName, actions, siteConfig, orderLabel } = this.props
    return (
      <React.Fragment>
        <Flex alignContent='center' justify='center'>
          {intl().formatMessage(messages.HowWouldYouLikeToPay)}
        </Flex>
        <WhiteSpace size='lg' />
        <Flex align='stretch' direction='column' className={classes.componentsPaymentMethodRender}>
          <Flex.Item className={classes.payTab} style={{ fontSize: 0 }}>
            {preferred && <DevicePay actions={this.props.actions} item={preferred} orderLabel={orderLabel} siteConfig={this.props.siteConfig} submit={this.props.submit} />}
          </Flex.Item>
          {data.map((item, index) => {
            var className = classes.payTab
            // this.state.index === index && (className += ' ' + classes.active)
            switch (item.tabType) {
              case 'PAY_METHODS':
              case 'MESSAGE_PAY':
                return (
                  <Flex.Item key={index} className={className} onClick={() => this.handleClick(item, index)}>
                    <PaymentMethodButton height={24} {...item} />
                  </Flex.Item>
                )
              case 'APP':
                return (
                  <Flex.Item key={index} className={className} onClick={() => this.handleClick(item, index)}>
                    <App {...item} submit={submit} loading={loading} pageName={pageName} />
                  </Flex.Item>
                )
              case 'MIX_PAY':
                return (
                  <Flex.Item key={index} className={className} onClick={() => this.handleClick(item, index)}>
                    <AaniPay {...item} actions={actions} item={item} siteConfig={siteConfig} submit={submit} orderLabel={orderLabel} loading={loading} pageName={pageName} />
                  </Flex.Item>
                )
              case 'DEVICE_PAY':
                return (
                  <Flex.Item key={index} className={className} onClick={() => this.handleClick(item, index)}>
                    <DevicePay {...item} actions={actions} item={item} siteConfig={siteConfig} submit={submit} orderLabel={orderLabel} />
                  </Flex.Item>
                )
              case 'WALLET_PAY':
                return (
                  <Flex.Item key={index} className={className} onClick={() => this.handleClick(item, index)}>
                    <AliPay {...item} actions={actions} item={item} siteConfig={siteConfig} submit={submit} orderLabel={orderLabel} loading={loading} pageName={pageName} />
                  </Flex.Item>
                )
            }
          })}
        </Flex>
        <Switch>
          <Route
            path='/pay-page/main/mobile-payment-container'
            render={(routeProps) => (
              <MobilePaymentContainer
                data={payPageMainState.payTabs}
                optAppItems={['introduceMedia']}
                optAddCardItems={['login', 'agreements']}
                loading={payPageMainState.loading}
                saveCard={payPageMainState.saveCard}
                // selected={this.state.index}
                siteConfig={siteConfig}
                actions={actions}
                submit={submit}
                pageName='paypage_home'
                {...routeProps}
              />
            )}
          />
        </Switch>
      </React.Fragment>
    )
  }
}

export default withRouter(PaymentMethodRender)
